export const video = {
  strict: true, // true => strict update state from component

  state: {
    videoToken: { item: null, token: null, requestTime: 0 },
    videoSlided: null,
    videoPlaying: false,
    videoVolume: { muted: true, volume: 1 },
  },

  getters: {},

  mutations: {
    SET_VIDEO_TOKEN: (state, payload) => {
      state.videoToken = payload;
    },
    VIDEO_PLAYING: (state, payload) => {
      state.videoPlaying = payload;
    },
    VIDEO_VOLUME: (state, payload) => {
      state.videoVolume = payload;
    },
  },
};
